import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-actionable',
  templateUrl: './modal-actionable.component.html',
  styleUrls: ['./modal-actionable.component.scss']
})
export class ModalActionableComponent implements OnInit {
  @Input() public iconSrc: string;
  @Input() public dataIconSrc: string;
  @Input() public title: string;
  @Input() public color: string;
  @Input() public data: any[];
  @Input() public hideDialog: boolean = false;
  @Output() openModalEvent = new EventEmitter<boolean>(false); 

  closeResult = '';

  constructor(private modalService: NgbModal) { }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'});
    this.openModalEvent.emit(true);
  }

  close() {
    this.modalService.dismissAll();
  }


  ngOnInit(): void {
  }

}
